<div class="layout-footer">
    <div class="footer-logo-container">
        <img id="footer-logo"src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/FocusCloud-80x80.png" style="width: 30px; height: auto;" alt="Focus Cloud" />
        <span class="app-name">Focus Command Center</span>
    </div>
    <span class="copyright">&#169; Focus POS Systems, Inc - {{moment().format('YYYY')}}</span>
</div>